import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Trash2, User } from "lucide-react";
import { PermsButton } from "../permissions/PermsButton";
import { localName } from "../../lib/localName";

// صف موظف داخل القسم: اسم قابل للنقر (يفتح ملفه) + زر صلاحيات + زر حذف.
export const DepartmentMemberRow = ({ user, onRemove }) => {
  const { t, i18n } = useTranslation();
  const isAr = (i18n.language || "ar").startsWith("ar");
  const display = localName(user, user.email);
  return (
    <li
      className="flex flex-wrap items-center gap-3 rounded-2xl border border-border/40 bg-background/60 px-3 py-2 shadow-neu-sm"
      data-testid={`dept-member-row-${user.id}`}
    >
      <Link
        to={`/employees/${user.id}`}
        target="_blank"
        rel="noreferrer"
        className="flex min-w-0 flex-1 items-center gap-3"
        data-testid={`dept-member-link-${user.id}`}
      >
        <span className="grid h-8 w-8 place-items-center rounded-2xl bg-primary/10 text-primary shadow-neu-in">
          <User className="h-4 w-4" />
        </span>
        <span className="min-w-0 flex-1">
          <p className="truncate text-xs font-bold">{display}</p>
          <p className="truncate text-[10px] text-muted-foreground">
            {user.email} {user.job_title ? `· ${user.job_title}` : ""}
          </p>
        </span>
      </Link>
      <PermsButton userId={user.id} userName={display} small />
      <button
        type="button"
        onClick={() => onRemove(user)}
        title={t("departments.members.remove")}
        className="rounded-2xl p-2 text-destructive shadow-neu-sm hover:bg-destructive/10"
        data-testid={`dept-member-remove-${user.id}`}
      >
        <Trash2 className="h-4 w-4" />
      </button>
    </li>
  );
};
